/**
 * Composable for handling date formatting and utilities
 */

export function useDateHelpers() {
  const isToday = (dateOrObject) => {
    if (!dateOrObject) return false;

    // Check if headline is "Heute" (most reliable indicator)
    if (dateOrObject.headline === "Heute") {
      return true;
    }

    // Fallback to date comparison
    const dateString = typeof dateOrObject === "string" ? dateOrObject : dateOrObject.date;
    if (!dateString) return false;

    const today = new Date();
    const performanceDate = new Date(dateString);
    return today.toDateString() === performanceDate.toDateString();
  };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d.getTime())) return date;
    return d.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const formatDateTitle = (date, outputYear = true) => {
    // if outputYear is false, we don't want to output the year
    const dateConfig = {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    };
    if (!outputYear) {
      delete dateConfig.year;
    }
    if (!date) return "";
    const d = new Date(date);
    const dayName = d.toLocaleDateString("de-DE", { weekday: "short" });
    const dateStr = d.toLocaleDateString("de-DE", dateConfig);

    if (isToday(d)) {
      return "Heute";
    }

    return `${dayName} ${dateStr}`;
  };

  const unixDateTimeToTime = (unixDateTime) => {
    if (!unixDateTime) return "";
    return new Date(unixDateTime * 1000).toLocaleTimeString("de-DE", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return {
    isToday,
    formatDate,
    formatDateTitle,
    unixDateTimeToTime,
  };
}

export function unixToDateString(unixDate) {
  if (!unixDate) return "";

  const date = new Date(unixDate * 1000);
  return date
    .toLocaleDateString("de-DE", {
      weekday: "short",
      day: "2-digit",
      month: "2-digit",
    })
    .replace(".,", "");
}
